import React from 'react';
import * as _ from 'lodash';
import axios from 'axios/index';
import qs from 'qs';
import {
  Modal,
  FormControl,
  Button,
  ButtonToolbar,
  FormGroup,
  ControlLabel,
  Row,
  Col,
} from 'react-bootstrap';

import FontAwesome from 'react-fontawesome';
import './NewPartItemModal.css';
import {setPartItem} from '../../../../stores/CarDamage/PartItemReducer';

class NewPartItemModal extends React.Component {

  constructor(...args) {
    super(...args);

    const {props} = this;

    this.state = {
      carType: (props.carType || '').toUpperCase(),
      partType: props.partType || '',
      part: props.partID,
      description: '',
      description_en: '',
      part_type_options: props.partList || [],
      car_type_options: [
        {label: 'รถเก๋ง', value: 'SEDAN'},
        {label: 'รถกระบะ', value: 'PICKUP'},
        {label: 'รถตู้', value: 'VAN'},
        {label: 'รถบรรทุก', value: 'TRUCK'},
      ],
    };
  }

  onEntered(e) {
    console.log('modal entered');
  }

  handleCloseButtonClick = (e) => {
    this.hide();
  };

  handleSaveButtonClick = (e) => {
    this.save();
    this.hide();
  };

  hide(e) {
    const {props, state} = this;

    if (typeof props.onHide === 'function') {
      props.onHide();
    }
  };

  save(e) {
    const {props, state} = this;

    let item = {
      car_type: props.carType,
      /**
       * Todo: Check partID if send if won't create new item
       */
      part_id: '',
      group_id: props.partType,
      description: state.description,
      description_en: state.description_en,
    };

    axios({
      method: 'post',
      url: `/damage/newpartitem`,
      data: qs.stringify({item}),
      headers: {'content-type': 'application/x-www-form-urlencoded'},
    }).then((response) => {
      if (typeof props.onSave === 'function') {
        props.onSave(item);
      }
    }).catch((error) => {
      console.log(error);
    });

  };

  render() {
    const {props, state} = this;
    const {show} = props;
    return (
        <Modal show={show} enforceFocus={false}
               onHide={props.onHide}
               onEntered={props.onEntered}
               dialogClassName="midwidth-dialog new-part-item-modal-container">
          <Modal.Header closeButton>
            <Modal.Title>{'เพิ่มรายการค่าอะไหล่'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>กลุ่มอะไหล่</ControlLabel>
                  <FormControl
                      disabled={true}
                      value={props.partType}
                      onChange={e => {
                        this.setState({partType: e.target.value});
                      }}
                      componentClass="select">
                    <option value={''}>เลือกกลุ่มอะไหล่</option>
                    {props.partList.map((item, index) => (
                        <optgroup key={index}
                                  label={`${item.description} (${item.description_en})`}>
                          {item.sublist.map((subitem, index) => (
                              <option key={index}
                                      value={subitem.group_id}>
                                {subitem.description} ({subitem.description_en})
                              </option>
                          ))}
                        </optgroup>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>ประเภทรถ</ControlLabel>
                  <FormControl
                      disabled={true}
                      value={state.carType}
                      onChange={e => {
                        this.setState({carType: e.target.value});
                      }}
                      componentClass="select">
                    {state.car_type_options.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <ControlLabel>ชื่อรายการ(ไทย)</ControlLabel>
                  <FormControl type={'text'}
                               value={state.description}
                               onChange={e => {
                                 this.setState({description: e.target.value});
                               }} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <ControlLabel>ชื่อรายการ(อังกฤษ)</ControlLabel>
                  <FormControl type={'text'}
                               value={state.description_en}
                               onChange={e => {
                                 this.setState(
                                     {description_en: e.target.value});
                               }} />
                </FormGroup>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div className={'text-right'}>
              <Button bsStyle={'primary'}
                      onClick={this.handleSaveButtonClick}>
                <FontAwesome name={'save'} /> บันทึก
              </Button>
              <Button bsStyle={'default'}
                      onClick={this.handleCloseButtonClick}>
                <FontAwesome name={'close'} /> ยกเลิก
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
    );
  }
}

export default NewPartItemModal;





// WEBPACK FOOTER //
// ./src/component/element/CarDamageForm/NewPartItemModal/NewPartItemModal.js